module.exports = __webpack_public_path__ + "static/36-be95bc45b6642018352d4e02eae5f2b1.png";